import { render, staticRenderFns } from "./TimeInfoGroup.vue?vue&type=template&id=3f580e4a&scoped=true"
import script from "./TimeInfoGroup.vue?vue&type=script&lang=js"
export * from "./TimeInfoGroup.vue?vue&type=script&lang=js"
import style0 from "./TimeInfoGroup.vue?vue&type=style&index=0&id=3f580e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f580e4a",
  null
  
)

export default component.exports